<script>
export default {
    created() {  
        if(this.user.user_level != 'SamfallifyCrew' && this.user.user_level != 'Redaktör')
        {
            this.$router.push('/login');           
        }   
    },
    data() {
        return { 
            
        }
    },   
    computed:
    {
        user()
        {
            return this.$store.state.user;
        },
        areas() {
            return  [
                { enabled: true, url: 'admin/news/', title: this.$store.state.settings.News.singular, icon: 'fa-solid fa-paper-plane font-gradient', text: 'Här kan du redigera de aktuella meddelanden som användaren möts av varje gång hen loggar in.' },
                { enabled: this.$store.state.settings.BoardMember.enabled, url: 'admin/board-members/', title: this.$store.state.settings.BoardMember.singular, icon: 'fa-solid font-gradient fa-people-line', text: 'Här hittar du allt du behöver för att kunna hålla '+this.$store.state.settings.BoardMember.singular+' aktuell. ' },
                { enabled: true, url: 'admin/members/', title: this.$store.state.settings.User.plural, icon: 'fa-solid font-gradient fa-people-roof', text: 'Här har du som redaktör möjlighet att lägga till nya '+this.$store.state.settings.User.plural+' och ta bort '+this.$store.state.settings.User.plural+' som till exempel flyttar.' },
                { enabled: this.$store.state.settings.WorkGroup.enabled, url: 'admin/work-groups/', title: this.$store.state.settings.WorkGroup.plural, icon: 'fa-solid font-gradient fa-person-digging', text: 'Här kan du lägga till nya '+this.$store.state.settings.WorkGroup.plural+'.' },
                { enabled: this.$store.state.settings.Forum.enabled, url: 'admin/forums/', title: this.$store.state.settings.Forum.singular, icon: 'fa-solid font-gradient fa-comments', text: 'Här kan du lägga till nya avdelningar i forumet.' },
                { enabled: this.$store.state.settings.BookingItem.enabled, url: 'admin/bookings/', title: this.$store.state.settings.BookingItem.plural, icon: 'fa-solid font-gradient fa-calendar-days', text: 'Hantera vad som går att hyra/låna inom din förening.' },
                { enabled: this.$store.state.settings.OpenApplication.enabled, url: 'admin/open-application/', title: this.$store.state.settings.OpenApplication.plural, icon: 'fa-solid font-gradient fa-clipboard-list', text: 'Skapa en intresseanmälan' },
                { enabled: this.$store.state.settings.Course.enabled, url: 'admin/courses/', title: this.$store.state.settings.Course.plural, icon: 'fa-solid font-gradient fa-user-graduate', text: 'Hantera kurser, kurslokaler och kursansvariga' },
                { enabled: true, url: 'admin/documents/', title: 'Ladda upp dokument', icon: 'fa-solid font-gradient fa-file', text: 'Här kan du hantera föreningens gemensamma dokumentation.' },
                { enabled: true, url: 'admin/image-vault/', title: 'Bildbanken', icon: 'fa-solid font-gradient fa-image', text: 'Här lägga du upp de bilder du vill använda i jamii.' },
                { enabled: true, url: 'admin/public-site/', title: 'Publika sidan', icon: 'fa-solid font-gradient fa-globe', text: 'Här kan du bestämma om föreningen ska ha en publik sida och ändra utseendet och innehållet på denna.' },
                { enabled: true, url: 'admin/appearance/', title: 'Utseende', icon: 'fa-solid font-gradient fa-palette', text: 'Här kommer du kunna lägga in föreningens egen logga och styra hur den används i appen.' },
                { enabled: this.$store.state.settings.Invitation.enabled, url: 'admin/invitations/', title: this.$store.state.settings.Invitation.plural, icon: 'fa-solid font-gradient fa-handshake-simple', text: 'Skapa '+this.$store.state.settings.Invitation.plural+' till årsmöten, städdagar, trivselaktiviter etc' },
                { enabled: true, url: 'admin/email/', title: 'Emailutskick', icon: 'fa-solid font-gradient fa-envelopes-bulk', text: 'Skicka mail till '+this.$store.state.settings.User.plural+', redaktörer eller ' + this.$store.state.settings.WorkGroup.plural+ '.' },
                { enabled: this.$store.state.settings.Statute.enabled, url: 'admin/statutes/', title: this.$store.state.settings.Statute.plural, icon: 'fa-solid font-gradient fa-gavel', text: 'Här kan du lägga upp föreningens stadgar.' },
                { enabled: this.$store.state.settings.RuleOfProcedure.enabled, url: 'admin/rules-of-procedure/', title: this.$store.state.settings.RuleOfProcedure.plural, icon: 'fa-solid font-gradient fa-person-harassing', text: 'Här kan du lägga upp föreningens ordningsregler' },
                { enabled: true, url: 'admin/settings/', title: 'Appens funktioner', icon: 'fa-solid font-gradient fa-sliders', text: 'Här kan du bestämma vilka funktioner i jamii som passar din förening. Det går även att ändra namn på mycket i jamii för att det ska passa just er verksamhet.' },
            ];
        }
    }
}
</script>
<template>
    <div v-fade-in>
        <main class="opacity-admin-bg overflow-auto position-relative">
            <div class="btn-admin Admin-go-to-user-tip">Tips! Du kan när som helst gå över till användarläget genom att klicka på <i class="fa-solid fa-user" style="color: black"></i> ovan.</div>              
            <h2>Hej Redaktör!</h2>
            <div>Här kan du anpassa appen efter föreningens behov. Välj någon av länkarna nedan för att börja anpassa...</div>  
            <div class=" margin-top-15">
                    <router-link :to="area.url" v-for="area in areas.filter(x => x.enabled)" class="g-25">
                        <div class="Admin-area">
                            <div>
                                <i :class=area.icon></i>
                            </div>
                            <div>
                                <h3>{{ area.title }}</h3>
                                <p> {{ area.text }}</p>
                                
                            </div>
                        </div>
                    </router-link>
            </div>         
        </main>
    </div>
</template>
<style scoped>
.Admin-go-to-user-tip {
    position: absolute;
    right: 19px;
    padding: 10px 20px;
    width: 260px;
    top: 11px;
}

.Admin-area
{
  padding:28px 20px;
  overflow: auto;
  float: left;
  width: calc(100% - 40px);
  height: 185px;
  overflow-y: hidden;
  border: 1px solid  rgba(250, 233, 197, 0.95);
}

.Admin-area:hover
{
  border: 1px solid #4c6675;
}

.Admin-area i
{
 font-size: 30pt;
 color: #4f5358 !important;
 background: none !important;
 -webkit-background-clip: border-box !important;
 background-clip: border-box !important;
 -webkit-text-stroke: 0 !important;
}

.Admin-area p
{
color: black;
}

.Admin-area h3
{
  color: #4f5358 !important;
}

@media only screen and (max-width: 1500px) {
    .Admin-area p
    {
    margin: 0px;
    font-size: 14px;
    line-height: 20px;
    }

    .Admin-area h3 {
    margin: 14px 0px 8px 0px;
    }

    .Admin-area
    {
        min-height: 190px;
    }
}
</style>
